import { type ClearCellsEvent } from '../events/types.ts';
import { type SelectionState } from '../state/types.ts';

import { type ReducerResponse, type SelectionReducerPolicies } from './types.ts';

/**
 * Since we have an input layer that accepts keystrokes
 * and to keep the UI separate from the input, the clear cells
 * logic was added here so we can have a selection of cells and
 * when backspace is pressed, can fire a clearCellsRequested event
 * which could wire up to Redux under the hood.
 *
 * This also allows us to easily toggle off this deletion should we disable editing.
 */
export function requestClearCellsReducer(
  state: SelectionState,
  event: ClearCellsEvent,
  policies: SelectionReducerPolicies
): ReducerResponse {
  if (state.mode === 'idle') {
    return { next: state, delta: { kind: 'noop' } };
  }

  if (!policies.canClearCells(state.selections)) {
    return { next: state, delta: { kind: 'noop' } };
  }

  return {
    next: state,
    delta: {
      kind: 'clearCellsRequested',
      source: event.source
    }
  };
}
